export default function () {
  jQuery(window).load(function() {
    var pathname = window.location.pathname;

    if ( pathname.indexOf('cart') > -1 ) {
      jQuery('.cart__progress-bar').addClass('cart');
    }

    if ( pathname.indexOf('checkout') > -1 ) {
      jQuery('.cart__progress-bar').addClass('checkout');
    }

    if ( pathname.indexOf('order-received') > -1 ) {
      jQuery('.cart__progress-bar').addClass('confirmation');
    }

  });
}



// WEBPACK FOOTER //
// ./scripts/components/SetupCartProgression.js